import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

// PM-12: historial de rutas de la pestaña (por índice de react-router) para volver a la pantalla de origen exacta.
const CLAVE = "aldia-rutas";
const leer = () => { try { return JSON.parse(sessionStorage.getItem(CLAVE)) || []; } catch { return []; } };

export const registrarRuta = (location) => {
  const idx = window.history.state?.idx;
  if (typeof idx !== "number") return;
  const rutas = leer();
  rutas[idx] = location.pathname + location.search;
  rutas.length = idx + 1;
  try { sessionStorage.setItem(CLAVE, JSON.stringify(rutas)); } catch { /* sin almacenamiento: se usa la ruta por defecto */ }
};

// Desde una ficha a su lista: si se llegó desde esa lista se retrocede (no se duplica en el historial); si no, se sustituye la ficha.
export const useIrAPadre = () => {
  const navigate = useNavigate();
  return (padre) => {
    const idx = window.history.state?.idx;
    const previa = typeof idx === "number" ? leer()[idx - 1] : null;
    if (previa && previa.split("?")[0] === padre) navigate(-1);
    else navigate(padre, { replace: true });
  };
};

// Vuelve a la última pantalla distinta de la actual (con sus filtros); si no hay, a `porDefecto`.
export const BotonVolver = ({ porDefecto = "/", testid }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const volver = () => {
    const idx = window.history.state?.idx;
    const rutas = leer();
    if (typeof idx === "number") {
      for (let j = idx - 1; j >= 0; j--) {
        if (rutas[j] && rutas[j].split("?")[0] !== pathname) { navigate(j - idx); return; }
      }
    }
    navigate(porDefecto);
  };
  return (
    <button data-testid={testid} onClick={volver}
      className="inline-flex items-center gap-1.5 text-[#3A6B56] font-semibold text-base min-h-[44px]">
      <ChevronLeft size={22} /> Volver
    </button>
  );
};
